module.exports = __webpack_public_path__ + "img/web1.1224a4b4.svg";